import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	digestsPageTitle: {
		defaultMessage: 'Digest Notifications',
		id: 'spa-apps-personal-settings-digests-notifications.digests-page-title',
		description:
			'Digest Notifications Personal Settings page title - this page contains settings relating to the digest notifications the user will recieve',
	},
});
